<div class="container">
  @if (isLoading) {
    <div class="grid-loading-overlay">
      <mj-loading text="Loading files..." size="medium"></mj-loading>
    </div>
  }
  <ag-grid-angular
    class="files-grid"
    [theme]="GridTheme"
    [rowData]="files"
    [columnDefs]="ColumnDefs"
    [defaultColDef]="DefaultColDef"
    [loading]="isLoading"
    (gridReady)="OnGridReady($event)">
  </ag-grid-angular>

  <mj-files-file-upload
    [CategoryID]="CategoryID"
    [disabled]="isLoading"
    (uploadStarted)="isLoading = true"
    (fileUpload)="handleFileUpload($event)"
  ></mj-files-file-upload>

  <mj-dialog
    [Visible]="!!editFile"
    Title="Edit file"
    [Width]="450"
    [MinWidth]="250"
    (Close)="resetEditFile()">
    @if (editFile) {
      <div class="edit-form-container">
        <form #templateForm="ngForm">
          <label class="mj-form-field">
            <span class="mj-form-label">Name</span>
            <input
              class="mj-input"
              name="name"
              [(ngModel)]="editFile.Name"
              required
              [disabled]="isLoading" />
          </label>
          <label class="mj-form-field">
            <span class="mj-form-label">Description</span>
            <input
              class="mj-input"
              name="description"
              [(ngModel)]="editFile.Description"
              [disabled]="isLoading" />
          </label>
        </form>
      </div>
    }
    <mj-dialog-actions>
      <button mjButton variant="primary" (click)="saveEditFile()" [disabled]="isLoading || !editFile?.Dirty">Save</button>
      <button mjButton (click)="resetEditFile()" [disabled]="isLoading">Cancel</button>
    </mj-dialog-actions>
  </mj-dialog>
</div>
